import { Injectable } from '@angular/core';
import { TipoLogradouro } from '@tivic-team/manager-ts/dist/grl';
import { TipoLogradouroController } from 'app/controllers/grl/tipo-logradouro.controller';
import { TipoLogradouroDTO } from 'app/model/dtos/grl/tipo-logradouro.dto';
import { LoaderService } from '../loader.service';
import { TipoLogradouroSearch } from './tipo-logradouro.search';


@Injectable()
export class TipoLogradouroService{

    constructor(
        private _tipoLogradouroController: TipoLogradouroController,
        private _loaderService: LoaderService
    ){}

    async save( tipoLogradouro: TipoLogradouro ): Promise< TipoLogradouro > {
        this._loaderService.show();

        if( tipoLogradouro.cdTipoLogradouro && tipoLogradouro.cdTipoLogradouro > 0 ) {
            
            return this._tipoLogradouroController.updateTipoLogradouro( tipoLogradouro ).finally( () => this._loaderService.hide() );
        } else {

            return this._tipoLogradouroController.createTipoLogradouro( tipoLogradouro ).finally( () => this._loaderService.hide() );
        }
    }

    async find(tipoLogradouroSearch?:TipoLogradouroSearch):Promise<TipoLogradouro[]>{
        try{return await this._tipoLogradouroController.find(tipoLogradouroSearch && tipoLogradouroSearch.getFilters() || null);}
        catch(error){return [];}
    }

    async findLogradouro( tipoLogradouroSearch?: TipoLogradouroSearch ):Promise< TipoLogradouro[] > {
        try {
            return await this._tipoLogradouroController.find( ( tipoLogradouroSearch && tipoLogradouroSearch.getFilters() ) || null ).finally( () => this._loaderService.hide() );
            
        } catch( error ) {
            this._loaderService.hide();
            return [];
        }
    }

    async get(cdTipoLogradouro:number):Promise<TipoLogradouroDTO>{
        this._loaderService.show();
        return this._tipoLogradouroController.get(cdTipoLogradouro).finally(() => this._loaderService.hide());
    }
    
    async getAll():Promise<TipoLogradouro[]>{
        this._loaderService.show();
        return this._tipoLogradouroController.find().finally(() => this._loaderService.hide());
    }

}